<template>
    <v-chip
        pill
        class="mr-3"
    >
        <router-link
            :to="'/'"
            style="text-decoration: none;"
        >
            Lecteur
        </router-link>
    </v-chip>
</template>

<script>
export default {
    name: 'PlayerChip'
};
</script>
